import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Plays from './liveFeed/LiveFeedPlays';
import LiveFeedPromos from './LiveFeedPromos';
import { makeInningHeader } from '../PlayFeed/PlayFeed';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';

const InningBlock = ({
    playsObj,
    inning,
    reverseChron,
    playsProps,
    isLoading
}) => {
    const { top = [], bottom = [] } = playsObj;
    const inningOrdinal = useTranslator('ranking_' + inning, inning);
    const replacement = { inning, inningOrdinal };
    const topText = useTranslator('inning_state_top', `Top ${inningOrdinal}`, replacement);
    const bottomText = useTranslator('inning_state_bottom', `Bottom ${inningOrdinal}`, replacement);
    const topDiv = top.length ? makeInningHeader(topText, isLoading, 1) : null;
    const bottomDiv = bottom.length ? makeInningHeader(bottomText, isLoading, 1) : null;
    return (
        <Fragment key={`inning-${inning}`}>
            {!reverseChron && <LiveFeedPromos inning={inning} type="feed" pos="bottom" />}

            {reverseChron ? bottomDiv : topDiv}
            <Plays playArr={reverseChron ? bottom : top} {...playsProps} />

            {reverseChron && <LiveFeedPromos inning={inning} type="feed" pos="bottom" />}

            {reverseChron ? topDiv : bottomDiv}
            <Plays playArr={reverseChron ? top : bottom} {...playsProps} />

            {reverseChron && <LiveFeedPromos inning={inning} type="feed" pos="top" />}
        </Fragment>
    );
};

InningBlock.propTypes = {
    playsObj: PropTypes.object.isRequired,
    inning: PropTypes.number.isRequired,
    reverseChron: PropTypes.bool,
    playsProps: PropTypes.object,
    isLoading: PropTypes.bool
};

export default InningBlock;
